import { useCallback } from 'react';

const useFormHandlers = (setFormValues) => {
  const handleChange = useCallback((field, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  }, [setFormValues]);

  const handleFileChangeLocal = useCallback((e, field) => {
    if (e && e.target && e.target.files) {
      const file = e.target.files[0];
      if (file) {
        setFormValues((prevValues) => ({
          ...prevValues,
          [field]: file,
        }));
      }
    }
  }, [setFormValues]);

  const handleRemoveImageLocal = useCallback((field) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: null,
    }));
  }, [setFormValues]);

  return {
    handleChange,
    handleFileChangeLocal,
    handleRemoveImageLocal,
  };
};

export default useFormHandlers;
